<template>

    <div class="newsletters-container no-scrollbar">

        <div class="news-head-container">

            <div class="news-head-title-container">

                <p v-if="!scanning" class="cf-title-3">{{ $t('cleaning_title') }}</p>

                <div v-else class="header-scann-container">

                    <lottie-loader :size="24"/>

                    <span class="header-scann-title cf-title-3">{{ $t('cleaning_scanning') }}</span>


                </div>

                <div>

                    <img v-if="!isFinish && !error && $mq !== 'lg' && boolScreenCardsMinHeight" :src="computedPreferenceImg" @click="togglePreference">

                    <a v-if="$mq !== 'lg'" class="my-actions-btn" href="/my-actions">
                        <img src="/img/icons/my-actions-blue.svg">
                    </a>

                </div>

            </div>

            <div v-show="newsletters.length" class="news-head-progress-container">

                <p class="progress-bar-text">

                    <strong>{{ treated }}/</strong>

                    <markdown :text="$tc('cleaning_list_total_treated', treated, {numberOfNewslettersTreated: totalLength})"></markdown>

                </p>

                <div class="progress-bar-background">

                    <div :style="{ width: updateProgress}" class="progress-bar-running"></div>

                </div>

            </div>

            <!-- keep div for flex space between-->
            <div>

                <a v-if="$mq === 'lg'" class="my-actions-btn" href="/my-actions">
                    <img src="/img/icons/my-actions-blue.svg">
                </a>

            </div>


        </div>


        <mq-layout v-if="!isFinish && !error" class="desktop-toggle-container" mq="lg">

            <div :class="{ 'desktop-toggle-active': !isList }" class="desktop-toggle desktop-toggle-left pointer" @click="togglePreference('cards')">

                <img :src="computedToggleCardsImg">

                <p :class="{ 'desktop-toggle-active': !isList }" class="desktop-toggle-text">{{ $t('cleaning_cards') }}</p>

            </div>

            <div :class="{ 'desktop-toggle-active': isList }" class="desktop-toggle desktop-toggle-right pointer" @click="togglePreference('list')">

                <img :src="computedToggleListImg">

                <p :class="{ 'desktop-toggle-active': isList }" class="desktop-toggle-text">{{ $t('cleaning_list') }}</p>

            </div>

        </mq-layout>


        <empty-page v-if="error && !isFinish"></empty-page>


        <div v-if="isFinish" class="congrats-container">


            <img :src="congratsImg" class="congrats-img">

            <h1 class="congrats-title">{{ congratsTitle }}</h1>

            <p class="congrats-text">{{ congratsText }}</p>

            <a class="congrats-link" @click="clickEndLink">{{ congratsLinkText }}</a>


        </div>

        <cleaning-list v-else-if="isList || !boolScreenCardsMinHeight"
                       :newsletters="newsletters"
                       :newslettersErrors="newslettersErrors"
                       :tuto="needTutoList"
                       @invalidGrant="newslettersInvalidGrant"
                       @requestDelete="requestDelete"
                       @requestKeep="requestKeep"
                       @requestUnsubscribe="requestUnsubscribe"
        ></cleaning-list>

        <card-container v-else
                        :extras="extras"
                        :newsletters="newsletters"
                        :newslettersErrors="newslettersErrors"
                        :tuto="needTutoCard"
                        @end="emptyCardArray"
                        @invalidGrant="newslettersInvalidGrant"
                        @requestDelete="requestDelete"
                        @requestKeep="requestKeep"
                        @requestUnsubscribe="requestUnsubscribe"
        ></card-container>

        <tab-bar></tab-bar>

        <modal-email-deconnected ref="MED"></modal-email-deconnected>

        <feedback :feedbackGoodPosition="feedbackGoodPosition" :isList="isList"></feedback>

        <terms-update></terms-update>

    </div>

</template>

<script>

import Api from '@/api'

import Storage from '@/helpers/storage'

import EmptyPage from '@/components/EmptyPage'
import Feedback from '@/components/Feedback/Feedback'
import CardContainer from '@/components/newsletters/CardContainer'
import TermsUpdate from '@/components/TermsUpdate'
import CleaningList from '@/components/newsletters/CleaningList'
import LottieLoader from '@/components/lottie/LottieLoader'
import Markdown from '@/components/Markdown'
import ModalEmailDeconnected from '@/components/modal/ModalEmailDeconnected'
import TabBar from '@/components/TabBar'
import Firebase from '@/modules/firebase'
import I18n from "@/modules/i18n";

export default {

    name: 'newsletters',

    components: {
        EmptyPage,
        Feedback,
        CardContainer,
        TermsUpdate,
        CleaningList,
        LottieLoader,
        Markdown,
        ModalEmailDeconnected,
        TabBar
    },

    computed: {

        updateProgress: function () {
            let percent = Math.round((this.treated * 100) / this.totalLength)
            percent = percent > 100 ? 100 : percent
            percent = percent < 0 ? 0 : percent
            return `${percent}%`
        },

        untreated: function () {
            return this.computedTotalLength - this.newsletters.length
        },

        computedPreferenceImg: function () {
            return this.isList ? '/img/icons/switch-to-cards-blue.svg' : '/img/icons/switch-to-list-blue.svg'
        },

        congratsImg: function () {
            return '/img/cards/mailbox_empty.svg'
        },

        congratsTitle: function () {
            return this.isInvalidGrant || this.scanning ? this.$t('cleaning_still_scanning_title') : this.$tc('cleaning_clean_title', 0)
        },

        congratsText: function () {
            return this.isInvalidGrant || this.scanning ? this.$t('cleaning_still_scanning_description') : this.$t('cleaning_clean_description')
        },

        congratsLinkText: function () {
            return this.isInvalidGrant || this.scanning ? this.$t('cleaning_actualize_cta') : this.$t('cleaning_list_cta_stat')
        },

        computedToggleListImg: function () {
            return this.isList ? '/img/icons/switch-to-list-white.svg' : '/img/icons/switch-to-list-grey.svg'
        },

        computedToggleCardsImg: function () {
            return this.isList ? '/img/icons/switch-to-cards-grey.svg' : '/img/icons/switch-to-cards-white.svg'
        },

        computedTotalLength: function () {
            return this.newsletters.length + this.newslettersErrors.length
        },

        feedbackGoodPosition() {

            let bool = false

            if (!this.isList && this.totalLength) {

                this.totalLength > 30 ?
                    bool = this.treated > 30 :
                    bool = this.treated === this.totalLength
            }

            return bool
        }
    },

    watch: {

        treated: function (value) {

            if (value === this.totalLength && this.isList) {
                this.showEnd()
            }

        },

        isFinish: function (bool) {
            if (bool) {
                this.batchEnd()
            }
        }
    },

    data() {

        return {

            isList: false,
            scanning: false,
            isFinish: false,
            treated: 0,
            isInvalidGrant: false,
            error: false,
            needTutoList: false,
            needTutoCard: false,
            newsletters: [],
            newslettersErrors: [],
            totalLength: 0,
            numberScreenCardsMinHeightNumber: 512,
            numberScreenCardsMinWidthNumber: 320,
            boolScreenCardsMinHeight: true,
            extras: [],
            tempUnsubscribe: [],
            tempKeep: [],
            tempDelete: [],
            timeoutId: 0,
            firebaseTimeBeforeBatch: 3000
        }

    },

    created() {

        this.isList = Storage.getItem('newslettersPreferences') === 'list'

        if (window && window.screen && window.screen.height < this.numberScreenCardsMinHeightNumber || window.screen.width < this.numberScreenCardsMinWidthNumber) {

            this.boolScreenCardsMinHeight = false

        }

    },

    mounted() {

        this.fetch()

        Firebase.getValue('action_delay_seconds')
            .then(stringTime => {
                const numberTime = parseInt(stringTime, 10)
                if (numberTime) {
                    this.firebaseTimeBeforeBatch = numberTime * 1000
                }
            })
            .catch()
    },

    methods: {

        fetch() {

            return Api.newsletters.get()
                .then(data => {
                    this.sortNewsletters(data)
                    this.extras = data.extras || []
                })
                .catch(() => {
                    this.error = true
                })
        },

        togglePreference(preference) {

            if (preference === 'list') {

                this.switchToList()

            } else if (preference === 'cards') {

                this.switchToCards()

            } else {

                if (this.isList) {

                    this.switchToCards()

                } else {

                    this.switchToList()
                }
            }

        },

        switchToList() {
            this.isList = true
            Storage.setItem('newslettersPreferences', 'list')
        },

        switchToCards() {
            this.isList = false
            Storage.setItem('newslettersPreferences', 'cards')
        },

        sortNewsletters(data) {

            const subscriptions = data.subscriptions

            if (data.done) {

                this.scanning = !!(data.mailboxes && data.mailboxes.filter(mailbox => !mailbox.done).length > 0)

                if (subscriptions && subscriptions.length) {

                    // sort array, invalidGrant to the end
                    const sortArray = [
                        ...subscriptions.filter(item => !item.invalidGrant),
                        ...subscriptions.filter(item => item.invalidGrant)
                    ]

                    this.newsletters = sortArray.map(card => {
                        card.selected = false
                        card.show = true
                        card.error = false
                        return card
                    })

                    if (I18n.get(this) === 'fr' && this.newsletters.length > 10) {
                        this.newsletters.splice(9, 0, {
                            type: 'greenfox',
                            tag: 'greenfox_card',
                            cta: 'https://app.adjust.com/ls6zp1s'
                        })
                    }

                    this.totalLength = this.newsletters.length

                    this.launchTuto()

                } else {

                    this.isFinish = true

                }

            } else {

                this.goFetch()

            }

        },

        goFetch() {

            this.$router.push({path: '/fetch'})

        },

        emptyCardArray() {

            this.isFinish = true
        },

        requestDelete(arrayDelete) {

            this.updateProgressBar('+', arrayDelete.length)

            this.cleanNewsletters(arrayDelete)

            this.waitBeforeSend('delete', arrayDelete)
        },

        requestUnsubscribe(arrayUnsubscribe) {

            this.updateProgressBar('+', arrayUnsubscribe.length)

            this.cleanNewsletters(arrayUnsubscribe)

            this.waitBeforeSend('unsubscribe', arrayUnsubscribe)

        },

        requestKeep(arrayKeep) {

            this.updateProgressBar('+', arrayKeep.length)

            this.cleanNewsletters(arrayKeep)

            this.waitBeforeSend('keep', arrayKeep)
        },

        newslettersRequestError(arrayDelete) {

            this.updateProgressBar('-', arrayDelete.length)

            arrayDelete.map(item => {
                item.error = true
                item.selected = false
                return item
            })

            this.newslettersErrors = [...this.newslettersErrors, ...arrayDelete]

        },

        updateProgressBar(symbol, number) {

            this.treated = (symbol === '+' ? this.treated + number : this.treated - number)

        },

        cleanNewsletters(arrayToClean) {

            arrayToClean.forEach(elClean => {
                this.newsletters.forEach((elNews, index) => {
                    if (elNews.email === elClean.email && elNews.sender === elClean.sender) {

                        this.newsletters.splice(index, 1)
                    }
                })

                this.newslettersErrors.forEach((elNews, index) => {

                    if (elNews.email === elClean.email && elNews.sender === elClean.sender) {

                        this.newslettersErrors.splice(index, 1)
                    }
                })
            })

        },

        showEnd() {

            this.isFinish = true
        },

        clickEndLink() {

            if (!this.error && !this.isInvalidGrant) {

                this.$router.push({path: '/stats'})

            }

        },

        launchTuto() {

            this.needTutoList = !Storage.getItem('needTutoList')
            this.needTutoCard = !Storage.getItem('needTutoCard')

        },

        newslettersInvalidGrant(email) {

            this.$refs.MED.open(email)

        },

        waitBeforeSend(type, arrayNewsletters) {

            switch (type) {
                case 'unsubscribe':
                    this.tempUnsubscribe = [...this.tempUnsubscribe, ...arrayNewsletters]
                    break
                case 'keep':
                    this.tempKeep = [...this.tempKeep, ...arrayNewsletters]
                    break
                case 'delete':
                    this.tempDelete = [...this.tempDelete, ...arrayNewsletters]
                    break
            }

            this.restartCounter()
        },

        restartCounter() {
            this.clearCounter()
            this.startCounter()
        },

        startCounter() {
            this.timeoutId = setTimeout(() => {
                this.sendNewslettersRequest()
            }, this.firebaseTimeBeforeBatch)
        },

        clearCounter() {
            clearInterval(this.timeoutId)
        },

        sendNewslettersRequest() {

            if (this.tempUnsubscribe.length) {
                Api.newsletters.unsubscribe(this.tempUnsubscribe)
                    .catch(() => {
                        this.newslettersRequestError(this.tempUnsubscribe)
                    })
                    .finally(() => {
                        this.tempUnsubscribe = []
                    })
            }

            if (this.tempKeep.length) {
                Api.newsletters.keep(this.tempKeep)
                    .catch(() => {
                        this.newslettersRequestError(this.tempKeep)
                    })
                    .finally(() => {
                        this.tempKeep = []
                    })
            }

            if (this.tempDelete.length) {
                Api.newsletters.delete(this.tempDelete)
                    .catch(() => {
                        this.newslettersRequestError(this.tempDelete)
                    })
                    .finally(() => {
                        this.tempDelete = []
                    })
            }
        },

        batchEnd() {
            this.clearCounter()
            this.sendNewslettersRequest()
        }
    },

    destroyed() {
        this.batchEnd()
    }
}
</script>

<style lang="scss">

/*Remove scrollbar on this page*/
*::-webkit-scrollbar {
    display: none;
}

</style>

<style lang="scss" scoped>

.newsletters-container {
    padding-bottom: 54px;
    background-color: $timberwolf;
    @media screen and (min-width: $above-tablet-length) {
        padding-bottom: 0;
        background-image: url("/img/background/cards-desktop.svg");
        background-repeat: no-repeat;
        background-position: bottom;
        background-size: cover;
        background-blend-mode: luminosity;
    }
}

.news-head-container {
    padding: 18px 16px 16px;
    display: flex;
    flex-direction: column;
    min-height: 101px;
    @media screen and (min-width: $above-tablet-length) {
        background-color: $white;
        padding: 24px 32px;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }
}

.news-head-title-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.header-scann-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}

.header-scann-title {
    margin-left: 8px;
}

.news-head-progress-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 16px;
    @media screen and (min-width: $above-tablet-length) {
        margin-top: 0px;
    }
}

.progress-bar-text {
    display: flex;
    flex-direction: row;
    font-size: 12px;
    line-height: 1.33;
    color: $grey;
}

.progress-bar-background {
    margin-top: 4px;
    width: 247px;
    height: 8px;
    background-color: #e1e7eb;
    border-radius: 4px;
}

.progress-bar-running {
    height: 8px;
    background-color: $green;
    border-radius: 4px;
}

.desktop-toggle-container {
    display: flex;
    min-height: 40px;
    margin: 32px 0;
    justify-content: center;
}

.desktop-toggle {
    width: 128px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    opacity: 0.25;
    border: 1px solid $grey;
}

.desktop-toggle-left {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
}

.desktop-toggle-right {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
}

.desktop-toggle-active {
    background-color: $blue;
    border-color: $blue;
    opacity: 1;
    color: $white;
}

.desktop-toggle-text {
    margin: 0 8px;
    font-size: 17px;
    font-weight: bold;
}

.congrats-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    align-items: center;
    justify-content: center;
    padding: 0 16px;
}

.congrats-img {
    width: 96px;
    object-fit: contain;
}

.congrats-title {
    margin-top: 16px;
    font-size: 17px;
    font-weight: bold;
    color: $midnight;
}

.congrats-text {
    margin-top: 4px;
    font-size: 12px;
    line-height: 1.33;
    color: $grey;
}

.congrats-link {
    margin-top: 8px;
    font-size: 12px;
    font-weight: bold;
    line-height: 1.33;
    color: $aquamarine;
    cursor: pointer;
}

.my-actions-btn {
    width: 24px;
    object-fit: contain;
    margin-left: 16px;
}

</style>
